import { CELL_STATE } from "../cell";
import { gameState } from "./gameState";

export const ADD_X_0 = [1, 0, -1, -1, -1, 0];
export const ADD_Y_0 = [0, 1, 1, 0, -1, -1];
export const ADD_X_1 = [1, 1, 0, -1, 0, 1];
export const ADD_Y_1 = [0, 1, 1, 0, -1, -1];

export const cellsFragment = document.createDocumentFragment();

export const cellsBlocked = function (i, j) {
    const cellState = gameState.cells[i][j].state;
    return [
      CELL_STATE.OUTSIDE,
      CELL_STATE.NON_BLOCKABLE_OUTSIDE,
      CELL_STATE.BLOCKED,
    ].includes(cellState);
  };
